import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from './Button';
import { Server } from 'lucide-react';
import { Link } from 'react-router-dom';

export function Hero() {
  const { t } = useTranslation();

  const scrollToFeatures = () => {
    const featuresSection = document.getElementById('features');
    if (featuresSection) {
      featuresSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="relative bg-gradient-to-br from-blue-900 to-blue-700 text-white">

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
        <div className="text-center">
          <Server className="w-12 h-12 md:w-16 md:h-16 mx-auto mb-6 md:mb-8" />

          <h1 className="text-3xl md:text-4xl lg:text-6xl font-bold mb-4 md:mb-6">
            {t('home.hero.title')}
          </h1>

          <p className="text-lg md:text-xl lg:text-2xl text-blue-100 mb-6 md:mb-8 max-w-3xl mx-auto">
            {t('home.hero.subtitle')}
          </p>

          <div className="flex flex-col md:flex-row gap-4 justify-center items-center">
            <Link to="/vps">
              <Button variant="primary">
                {t('home.hero.cta.primary')}
              </Button>
            </Link>

            <Link to="/vps#plans">
              <Button variant="secondary">
                {t('home.hero.cta.secondary')}
              </Button>
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-gray-100 to-transparent"></div>
    </div>
  );
}
